// extracted by mini-css-extract-plugin
module.exports = {"root":"NoShows_root__j4ku2"};